import { render, staticRenderFns } from "./CompletedAuctionsCardMobile.vue?vue&type=template&id=4d09a91f&scoped=true&"
import script from "./CompletedAuctionsCardMobile.vue?vue&type=script&lang=js&"
export * from "./CompletedAuctionsCardMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09a91f",
  null
  
)

export default component.exports